import { ActionTypes } from "../constants";

const reduceCategories = (state = null, action) => {

    switch (action.type) {
        case ActionTypes.GET_CATEGORIES_SUCCESS:
            return action.data || [];

        case ActionTypes.GET_CATEGORIES_FAILURE:
            return [];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceCategories;
